import { render } from "./GroupsContent.vue?vue&type=template&id=3ec82c3a&ts=true"
import script from "./GroupsContent.vue?vue&type=script&lang=ts"
export * from "./GroupsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__